import React from 'react';
import DetailsIcon from '@material-ui/icons/Visibility';
import MenuItem from 'components/Menu/MenuItem';
// @ts-ignore
const MenuDetailsItem = React.forwardRef((props, ref) => {
    return React.createElement(MenuItem, Object.assign({ ref: ref, icon: React.createElement(DetailsIcon, null), text: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C" }, props));
});
export default React.memo(MenuDetailsItem);
